// istanbul ignore file
/**
 * Imports CustomerEditModule from shared-ui
 */
import type { CustomerEditLazyModuleProps } from '@makemydeal/dr-sales-checkin-types';
import { createRemoteModule } from '@makemydeal/dr-shared-components';
import type { FunctionComponent } from 'react';

export const CustomerEditModule: FunctionComponent<CustomerEditLazyModuleProps> = createRemoteModule<CustomerEditLazyModuleProps>(
    'customer',
    './CustomerEditModule'
);
